"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
function getOptionsForFeature(feature) {
    return store_1.default.options[feature];
}
exports.default = getOptionsForFeature;
//# sourceMappingURL=getOptionsForFeature.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-outlook-service-options/lib/selectors/getOptionsForFeature.js
// module id = 2134
// module chunks = 2 3 4 39 49 108